import React from "react";

import { Grid, Stack } from "@mui/material";

import { Heading1 } from "../../atoms/Typography/Heading/Heading";
import { Carousel } from "../../molecules/Carousel/Carousel";

const RowWrap = ({
  text,
  children,
  height,
  gap,
  isCarouselWrap,
  flexDirection,
}) => {
  return (
    <Stack
      height={height}
      display={"flex"}
      rowGap={gap}
      flexDirection={flexDirection || "row"}
    >
      <Heading1 text={text} />
      {!isCarouselWrap ? (
        <Grid
          container
          height={"100%"}
          width={"100%"}          
          flex={"flex"}
          flexDirection={"row"}
          columnGap={"32px"}
        >
          {children}
        </Grid>
      ) : (
        <Carousel>{children}</Carousel>
      )}
    </Stack>
  );
};

export default RowWrap;
